import {bemClassName} from 'bem-components-connector'

import './style.scss'

export const Radiobutton = ({key, id, name, number, label, description, imgUrl, componentName, answersOnQuestions, setAnswersOnQuestions}) => {

    const block = bemClassName('radiobutton-with-img'),
          changeHandler = (e) => {
            let target = e.target

            localStorage.setItem(componentName, target.id)

            setAnswersOnQuestions((answersOnQuestionsOld) => {
                const answersOnQuestionsDraft = {...answersOnQuestionsOld}
                answersOnQuestionsDraft[componentName] = target.id

                return answersOnQuestionsDraft
            })
          },
          isRadioChecked = answersOnQuestions[componentName] === id


    return (<div className={`choice__act ${block()}`} key={key}>
        <input id={id}
               type={'radio'}
               name={name}
               checked={isRadioChecked}
               onChange={changeHandler}
        />
        <label id={id} className={block('label')} >

            <div className={block('text-wrapper')}>
                <p className={block('title')} >
                    {label}
                </p>
                {description ? <p className={block('description')}>{description}</p> : null}
            </div>

            {imgUrl ? <img className={block('illustration')} src={imgUrl} alt="img"/> : null}

        </label>
    </div>)

}
